export type ForumComposeMedia = {
  imageCount?: number;
  youtubeUrl?: string;
};

export type ForumComposeKind = 'post' | 'video' | 'photo';

/** API requires title; media forms derive it from the caption. */
export function forumCaptionTitle(caption: string, emptyFallback: string): string {
  const trimmed = caption.trim();
  if (!trimmed) return emptyFallback;
  const firstLine = trimmed.split(/\r?\n/, 1)[0] ?? trimmed;
  return firstLine.length > 80 ? `${firstLine.slice(0, 77)}…` : firstLine;
}

/** @deprecated Prefer forumCaptionTitle(caption, 'Video') */
export function forumVideoTitleFromCaption(caption: string): string {
  return forumCaptionTitle(caption, 'Video');
}

export function forumComposeReady(
  title: string,
  body: string,
  media?: ForumComposeMedia,
  kind: ForumComposeKind = 'post',
): boolean {
  if (kind === 'video') {
    return Boolean(media?.youtubeUrl?.trim());
  }
  if (kind === 'photo') {
    return (media?.imageCount ?? 0) > 0;
  }
  if (!title.trim()) return false;
  return Boolean(body.trim());
}
